import { render } from "./SectionVideos.vue?vue&type=template&id=301483a4&scoped=true"
import script from "./SectionVideos.vue?vue&type=script&lang=js"
export * from "./SectionVideos.vue?vue&type=script&lang=js"

import "./SectionVideos.vue?vue&type=style&index=0&id=301483a4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301483a4"]])

export default __exports__